<template>
  <b-row class="pt-1 pb-2">
    <b-col>
      <p class="divider mb-0 small gray-300">{{ dividerWord }}</p>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'SduiLabeledDivider',
  props: {
    dividerWord: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped lang="scss">
.divider {
  display: flex;
  flex-direction: row;
  margin: auto;
  max-width: 90%;
}
.divider::before,
.divider::after {
  content: '';
  flex: 1 1;
  border-bottom: 1px solid;
  margin: auto;
}
.divider::before {
  margin-right: 10px;
}
.divider::after {
  margin-left: 10px;
}
</style>
